import { Modal } from '@almbrand/modal';
import { PdfModal } from '@almbrand/pdfmodal';
import { RichText } from '@almbrand/richtext';
import { ThemeNames } from 'constantsValues/themeNames';
import { useThemeName } from 'hooks/useThemeName';

export interface PreviewModalProps {
	displayAsPdf: boolean;
	data: string;
	handleMessageDownload: () => void;
	onClose: () => void;
}

export const PreviewModal: React.FC<PreviewModalProps> = ({ displayAsPdf, data, handleMessageDownload, onClose }) => {
	const trackingThemeName = useThemeName();
	const isCodan = trackingThemeName === ThemeNames.codan;

	return displayAsPdf ? (
		<PdfModal
			pdfSrc={data}
			buttonSizes={isCodan ? 'small' : 'large'}
			closeButtonProps={{
				onClick: onClose,
				ariaLabel: 'Luk',
				label: 'Luk besked',
			}}
			downloadButtonProps={{
				onClick: handleMessageDownload,
				ariaLabel: 'Download',
				label: 'Download besked',
			}}
		/>
	) : (
		<Modal
			handleClose={onClose}
			actionButtonProps={{ title: 'Download', type: 'tertiary', onClick: handleMessageDownload }}
			mode='default'
			mobileVariation='default'
		>
			<RichText description={data} />
		</Modal>
	);
};
